import {
  Component,
  OnInit,
  OnChanges,
  ChangeDetectionStrategy,
  SimpleChanges,
  ViewChild,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTable } from '@angular/material/table';
import { PartnerDto } from 'src/app/domain/models/dto/partner.dto';
import { ResponseTableModel } from 'src/app/domain/models/response-table.model';
import { BoobleModalService } from 'booble-modal';
import { PartnerConfigComponent } from '../../modals/partner-config/partner-config.component';

@Component({
  selector: 'app-table-partners-admin',
  templateUrl: './table-partners.component.html',
  styleUrls: ['./table-partners.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePartnersComponent implements OnInit, OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<PartnerDto>;

  @Input() data: PartnerDto[];
  @Input() displayedColumns: string[] = [
    'companyName',
    'cnpj',
    'spread',
    'tariff',
    'institutionalSpread',
    'agencyNumber',
    'spreadBanking',
    'action',
  ];
  @Input() pageNumber: number = 0;
  @Input() pageSize: number = 10;
  @Input() totalElements: number;

  selection = new SelectionModel<PartnerDto>(true, []);
  public dataSource: MatTableDataSource<PartnerDto> = new MatTableDataSource(
    [],
  );

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private modalService: BoobleModalService,
  ) {}

  ngOnInit() {
    this.pageSize = +(sessionStorage.getItem('partners-page-size') || 5);
    this.pageNumber = +(sessionStorage.getItem('partners-page-number') || 0);

    this.dataSource = new MatTableDataSource(this.data);
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.paginator._intl.getRangeLabel = (
        page: number,
        pageSize: number,
        length: number,
      ) => {
        if (length === 0 || pageSize === 0) return '0 de ' + length;
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex =
          startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;
        return 'Exibindo ' + endIndex + ' de ' + length + ' parceiros';
      };

      const sortState: Sort = { active: 'companyName', direction: 'asc' };
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']?.currentValue) {
      this.dataSource = new MatTableDataSource<PartnerDto>(
        changes['data'].currentValue,
      );
      if (this.paginator) this.dataSource.paginator = this.paginator;
      if (this.sort) this.dataSource.sort = this.sort;
      if (this.table) this.table.renderRows();
    }
  }

  changePageEvent({
    pageSize,
    pageIndex,
  }: {
    pageSize: number;
    pageIndex: number;
  }) {
    sessionStorage.setItem('partners-page-size', String(pageSize));
    sessionStorage.setItem('partners-page-number', String(pageIndex));
  }

  onRowToggled(row: PartnerDto) {
    this.selection.toggle(row);
  }

  isAllSelected() {
    return this.selection.selected?.length === this.dataSource.data.length;
  }

  openPartnerConfigModal(partner: PartnerDto) {
    this.modalService.present(PartnerConfigComponent, partner);
  }
}
